import Phaser from 'phaser';

export function getDevicePixelRatio(): number {
	if (typeof window === 'undefined') {
		return 1;
	}

	return window.devicePixelRatio || 1;
}

export function syncLetterPartyCanvasSize(game: Phaser.Game, container: HTMLElement): void {
	const width = Math.max(1, Math.round(container.clientWidth || 1));
	const height = Math.max(1, Math.round(container.clientHeight || 1));
	const devicePixelRatio = getDevicePixelRatio();

	game.canvas.style.width = `${width}px`;
	game.canvas.style.height = `${height}px`;
	game.scale.resize(
		Math.max(1, Math.round(width * devicePixelRatio)),
		Math.max(1, Math.round(height * devicePixelRatio)),
	);
}
